import type { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { isStringNotEmpty } from '../utils/objectUtils';
import { appendQueryString, getForwardedQueryString } from '../utils/forwardedQueryUtils';
import ReadyRxLogo from '../assets/images/RX_Logo_Black.png';
import CONSTANTS from '../constants';
import styles from './BrandLogoLink.module.css';

interface BrandLogoLinkProps {
	className?: string;
	logoClassName?: string;
}

// the visitor's query rides along so a coupon or ad click id arriving in the app is not lost on the way back
const BrandLogoLink = ({ className = '', logoClassName = styles.logo }: BrandLogoLinkProps): ReactElement => {
	const [searchParams] = useSearchParams();

	const linkClassName = [styles.link, className].filter(isStringNotEmpty).join(' ');

	return (
		<a href={appendQueryString(CONSTANTS.BRAND_SITE_URL, getForwardedQueryString(searchParams))} className={linkClassName}>
			<img src={ReadyRxLogo} alt={CONSTANTS.COMPANY_NAME_SPOKEN} className={logoClassName} />
		</a>
	);
};

export default BrandLogoLink;
